module.exports = __webpack_public_path__ + "img/skupina_white.1d0587e1.svg";